export default __webpack_public_path__ + "static/media/share_screen.35f2d549.svg";